<template>
    <div id="content" class="full">
        <div class="status_user">
            Statut en cours :
            <div @click="toggleStatus('')" v-if="status === 'ABS'">
                <font-awesome-icon icon="user-times"></font-awesome-icon> <span>Absent</span>
            </div>
            <div @click="toggleStatus('ABS')" v-else>
                <font-awesome-icon icon="user"></font-awesome-icon> <span>Présent</span>
            </div>
        </div>
        <div id="dossiers" class="ecran bloc col-lg-12 col-md-12 col-sm-12 col-xs-12" style="display:block;">
            <div class="content-bloc">
                <ul class="lst-saisie" id="lst-saisie">
                    <template v-for="value in demandesToModer">
                        <li @click="goToDossier(value)">
                            <div class="col-1 text-center no-padding">
                                <div class="btn-type">
                                    <font-awesome-icon :icon="getIcnMarker(value.marker)"></font-awesome-icon>
                                </div>
                                <div class="hover-thumb">
                                    <font-awesome-icon icon="eye"></font-awesome-icon>
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="title-saisie">{{ value.ident }}</div>
                                <div class="date-saisie">- {{ value.date_notif }}</div>
                                <div class="infos-saisie">
                                    <div class="user-saisie">
                                        <font-awesome-icon icon="user"></font-awesome-icon>
                                        <template v-if="value.prenom == ''"> {{ value.raison_sociale }}</template>
                                        <template v-else> {{ value.prenom }} {{ value.nom }}</template>
                                    </div>
                                    <div class="separator-saisie">-</div>
                                    <div class="adresse-saisie">
                                        <font-awesome-icon icon="map-marker"></font-awesome-icon>
                                        {{ value.adresse }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 text-center no-padding">
                                <div class="actions-saisie">
                                    <div v-if="typeof value.avis !== 'undefined' && value.avis === 't'"
                                        class="btn-action green">
                                        <font-awesome-icon icon="thumbs-up"></font-awesome-icon>
                                    </div>
                                    <div v-else-if="typeof value.avis !== 'undefined' && value.avis === 'f'"
                                        class="btn-action">
                                        <font-awesome-icon icon="thumbs-down"></font-awesome-icon>
                                    </div>
                                    <div v-else-if="typeof value.date_lecture !== 'undefined' && value.date_lecture !== ''"
                                        class="btn-action blue">
                                        <font-awesome-icon icon="eye"></font-awesome-icon>
                                    </div>
                                    <div v-else class="btn-action orange">
                                        <font-awesome-icon icon="eye-slash"></font-awesome-icon>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Vuex from "vuex";
import router from "@/router";

export default {
    name: "Moderation",
    async mounted() {
        await this.getDemandesToModer({ userId: this.userConnected.userId, dossier: JSON.parse(localStorage['env_moder']).dos_cod_t });
        this.setNeedReturn(true);
    },
    computed: {
        ...Vuex.mapGetters("Demande", ['demandesToModer', 'status']),
        ...Vuex.mapGetters("Authentification", ["userConnected"]),
        ...Vuex.mapGetters("Environnement", ["envModer"]),
        ...Vuex.mapGetters("Application", ['needReturn'])
    },
    methods: {
        ...Vuex.mapActions("Demande", ["getDemandesToModer", "setStatus"]),
        ...Vuex.mapActions("Application", ["setNeedReturn"]),
        async toggleStatus(status) {
            let form = {
                userId: this.userConnected.userId,
                dossier: JSON.parse(localStorage['env_moder']).dos_cod_t,
                status: status
            };

            await this.setStatus(form);
        },
        goToDossier(dossier) {
            router.push({ name: 'ficheModer', params: { id: dossier.id, layername: dossier.marker } });
        },
        getIcnMarker(marker) {
            let icn_fa = "";

            switch (marker) {
                case "odp_travaux":
                    icn_fa = "wrench";
                    break;
                case "odp_demenagement":
                    icn_fa = "archive";
                    break;
                case "odp_stationnement":
                    icn_fa = "car";
                    break;
            }

            return icn_fa;
        }
    },
    created() {
        this.interval = setInterval(
            () =>
                this.getDemandesToModer({
                    userId: this.userConnected.userId,
                    dossier: JSON.parse(localStorage['env_moder']).dos_cod_t,
                }),
            10000
        );
    },
    beforeDestroy() {
        clearInterval(this.interval);
    }
};
</script>

<style scoped></style>